import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=2e80ff57"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e80ff57')) {
      api.createRecord('2e80ff57', component.options)
    } else {
      api.reload('2e80ff57', component.options)
    }
    module.hot.accept("./Sessions.vue?vue&type=template&id=2e80ff57", function () {
      api.rerender('2e80ff57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/sessions/Sessions.vue"
export default component.exports